<template>
  <v-container fluid class="ma-0 pa-0">
    <v-row align-content="center" align="center" justify="center">
      <v-col cols="12" class="py-12">
        <v-container>
          <v-row>
            <v-col cols="12" lg="8">
              <div class="px-2">
                <div class="home-header-2 mt-6 mb-8">
                  Manage my appointments
                </div>
                <div class="mb-12 home-text-2">
                  <p class="mb-4">
                    You <b>can</b> use this service to:
                  </p>
                  <ul>
                    <li>cancel a future appointment which was booked using this service</li>
                    <li>reschedule a future appointment which was booked using this service</li>
                    <li>view appointments you previously booked using this service</li>
                  </ul>
                  <br />
                  <p>
                    At this time, you <b>cannot</b> use this service to:
                  </p>
                  <ul>
                    <li>manage appointments booked outside this service, such as GP or local pharmacy  </li>
                  </ul>
                  <br />
                  <p>
                    <b>What do I need to log in?  </b>
                  </p>
                  <p>
                    You will need to provide your name and date of birth, plus the mobile number or email address that you booked with.
                  </p>
                  <p>
                    You can also login by clicking the link in any email or SMS we send you about your appointment.
                  </p>

                </div>
                <v-btn
                    href="https://vaccinations.hscni.net/portal"
                    color="#006078"
                    class="mb-12 v-btn--primary"
                >
                  Log in
                </v-btn>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'ManageMyAppointments'
};
</script>
